import { render, staticRenderFns } from "./index_page.vue?vue&type=template&id=0ceeabaa&scoped=true&"
import script from "./index_page.vue?vue&type=script&lang=js&"
export * from "./index_page.vue?vue&type=script&lang=js&"
import style0 from "./index_page.vue?vue&type=style&index=0&id=0ceeabaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceeabaa",
  null
  
)

export default component.exports